import { StorePreorderVariant } from "@/types/global"

export function isPreorder(preorderVariant?: StorePreorderVariant | null): boolean {
  if (!preorderVariant) return false
  if (preorderVariant.status !== "enabled") return false
  return new Date(preorderVariant.available_date) > new Date()
}

export function formatPreorderDate(availableDate: string): string {
  return new Date(availableDate).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}
